var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "client"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ShowList),
      expression: "ShowList"
    }],
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter fa-xs",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), (_vm.addProductFlag == true) ? _c('div', {
    staticClass: "card-actions"
  }, [_c('router-link', {
    staticClass: "btn-setting d-sm-down-none",
    attrs: {
      "to": 'pushproduct',
      "data-toggle": "tooltip",
      "title": "Add Product"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg"
  })])], 1) : _vm._e()]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validatevalues($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [(_vm.showSelectMerchant) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize '></i>"
    }
  }, [_c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "height": "32px",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "options": _vm.listMerchantData1,
      "placeholder": _vm.$t('common.merchantPlaceholder'),
      "selected-option": _vm.item
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.merchantnameFlt),
      callback: function($$v) {
        _vm.merchantnameFlt = $$v
      },
      expression: "merchantnameFlt"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('product.clientProductId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.clientProductIdPlaceHolder'),
      "id": "clientproductid"
    },
    model: {
      value: (_vm.clientproductid),
      callback: function($$v) {
        _vm.clientproductid = $$v
      },
      expression: "clientproductid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('product.eanCode')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('alpha_num'),
      expression: "'alpha_num'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('productid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.eanCodePlaceHolder'),
      "id": "productid",
      "name": "productid",
      "minlength": "0"
    },
    model: {
      value: (_vm.productid),
      callback: function($$v) {
        _vm.productid = $$v
      },
      expression: "productid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.producttype')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.producttypedropdown),
      expression: "producttypedropdown"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "producttypedropdown"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.producttypedropdown = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.producttype')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Simple"
    }
  }, [_vm._v("Simple")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Bundle"
    }
  }, [_vm._v("Bundle")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('product.productName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-product-hunt'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.productNamePlaceHolder'),
      "id": "productname"
    },
    model: {
      value: (_vm.productname),
      callback: function($$v) {
        _vm.productname = $$v
      },
      expression: "productname"
    }
  })], 1)], 1), _vm._v(" "), (_vm.client != '') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('product.productCategory')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productcategory),
      expression: "productcategory"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "productcategory"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.productcategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getProductSubCategory]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.productCategoryPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listProductCategory), function(category_obj) {
    return _c('option', {
      domProps: {
        "value": category_obj.productcategory
      }
    }, [_vm._v(_vm._s(category_obj.productcategory))])
  })], 2)])], 1) : _vm._e(), _vm._v(" "), (_vm.client != '') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('product.productSubCategory')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productsubcategory),
      expression: "productsubcategory"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "productsubcategory"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.productsubcategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.productSubCategoryPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listProductsubCategory), function(subcategory_obj) {
    return _c('option', {
      domProps: {
        "value": subcategory_obj.productsubcategory
      }
    }, [_vm._v(_vm._s(subcategory_obj.productsubcategory))])
  })], 2)])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block !important",
      "margin-top": "30px",
      "width": "16px"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    staticStyle: {
      "display": "inline-block",
      "height": "16px",
      "width": "16px"
    },
    attrs: {
      "type": "checkbox",
      "id": "only_outsideproducts",
      "name": "only_outsideproducts"
    },
    on: {
      "change": function($event) {
        _vm.onlyoutsideproducts($event)
      }
    },
    model: {
      value: (_vm.only_outsideproducts),
      callback: function($$v) {
        _vm.only_outsideproducts = $$v
      },
      expression: "only_outsideproducts"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px",
      "color": "green !important"
    }
  }, [_c('label', {
    attrs: {
      "for": "only_outsideproducts"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('product.showOutsideProducts')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(_vm._s(_vm.$t('inwardList.search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFlt
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.reset')))])])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ShowList),
      expression: "ShowList"
    }],
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "form-group row expand",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader s2 o1"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('product.table.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader s2 o2"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('product.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 s1 o3 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), (_vm.download && _vm.listProductData.length > 0) ? _c('div', {
    staticClass: "col-md-2 cardlistheader s1 o4 "
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.download')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listProductData.length > 0) ? _c('div', {
    staticClass: "col-md-1 ss o4 csvbtn"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download CSV"
    },
    on: {
      "click": function($event) {
        _vm.getProductData(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.limitExeed && _vm.show && _vm.listProductData.length > 0) ? _c('div', {
    staticClass: "col-md-1 ss o4 cxlsbtn"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download Excel"
    },
    on: {
      "click": function($event) {
        _vm.getAuditListForXLS(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.listProductData.length > 0) ? _c('div', {
    staticClass: "col-md-1 ss o4 cxlsbtn"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton ",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": "Download Excel",
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-hover table table-bordered",
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.clientProductId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.productID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.eanCode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.productName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.integrationProductid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.color')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.size')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.manufacturer')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.mrp')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.merchantName')))])]), _vm._v(" "), (_vm.activemrpflag) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.activemrp')))])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.action')))])])])]), _vm._v(" "), _c('tbody', [(_vm.clientid == '' || (_vm.listProductData && _vm.listProductData.length == 0)) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('product.table.columns.searchProducts')))])]) : _vm._e(), _vm._v(" "), (_vm.clientid != '' && _vm.searchFlag == true && (_vm.listProductData && _vm.listProductData.length == 0)) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.productListNotFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listProductData), function(data, index) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center ",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.integrationproductid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.color))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.size))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.brand))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.merchantname))]), _vm._v(" "), (_vm.activemrpflag) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.activemrp))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-left": "2px",
        "text-align": "center"
      }
    }, [(_vm.editProductFlag == true && _vm.user_type != 'client_user') ? _c('span', [_c('i', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-edit text-successedit fa-lg mt-2 ml-3",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getProductRowData(data)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.viewProductFlag == true) ? _c('span', [_c('i', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye text-successeye fa-lg mt-2 ml-3",
      on: {
        "click": function($event) {
          _vm.loadProduct(data)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (data.bundlesku === 1) ? _c('span', [_c('i', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-cubes fa-lg mt-4",
      on: {
        "click": function($event) {
          _vm.loadBundleProduct(data)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.editProductFlag == false && _vm.viewProductFlag == false) ? _c('span', [_vm._v("--")]) : _vm._e()])])
  })], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listProductData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.closeProductModal = false
      }
    },
    model: {
      value: (_vm.productDetailModal),
      callback: function($$v) {
        _vm.productDetailModal = $$v
      },
      expression: "productDetailModal"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('printProductDetails.productDetails')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeProductModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-body ",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.clientProductId')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.clientproductid))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.productId')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.productid))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.productName')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.productname))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.productDescription')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.productdescription))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.productCategory')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.productcategory))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.productSubCategory')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.productsubcategory))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.photo')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [(_vm.productUploadLabelUrl1) ? _c('img', {
    attrs: {
      "src": _vm.productUploadLabelUrl1,
      "width": "150px"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.productUploadLabelUrl1) ? _c('img', {
    attrs: {
      "src": "static/img/noimg.png",
      "width": "150px"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.brand')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.brand))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.color')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.color))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.size')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.size))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.shelfLifeDuration')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.shelflifeduration))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.unitWeight')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.unitweight))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.unitDimensonUom')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.unitdimensonuom))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.unitLength')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.unitlength))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.unitBreadth')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.unitbreadth))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.unitHeight')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.unitheight))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.uomTemp')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.uomtemp))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isTempSensitive')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.istempsensitive))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.minTemp')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.mintemp))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.maxTemp')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.maxtemp))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.expiryDate')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [(_vm.productDetailData.expirydate) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.productDetailData.expirydate)))]) : _vm._e()]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.mrp')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.mrp))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.hsnCode')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.hsncode))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.gstRate')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.hsnrate))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.primaryUom')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.primaryUom))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.secondaryUom')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.secondaryuom))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isLotcontrol')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.lotcontrol))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isSerialcontrol')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.isserialcontrol))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isExpirycontrol')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.isexpirycontrol))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isHazardous')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.ishazardous))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isFragile')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.isfragile))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isflammable')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.isflammable))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isLiquid')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.isliquid))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.mfgCode')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.mfgcode))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.mfgCode')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.attribute1))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.expiryControlled')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.expirycontrolled))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.serializeControl')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.serializecontrol))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.velocityCode')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.velocitycode))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.productTax')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.producttax))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isMRPTracked')))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.ismrptracked))])]), _vm._v(" "), (_vm.activemrpflag) ? _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Active MRP ")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.activemrp))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  })]) : _vm._e()])])])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.closeBundleProductModal = false
      }
    },
    model: {
      value: (_vm.bundleProductModal),
      callback: function($$v) {
        _vm.bundleProductModal = $$v
      },
      expression: "bundleProductModal"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(this.$t('printProductDetails.bundleProductDetails')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeBundleProductModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.sku')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.productName')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.productId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.quantity')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.mrp')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bundleProductMappingDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.quantity))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mrp))])])
  }))])])])])])])], 1)]), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editproductmodal),
      expression: "editproductmodal"
    }]
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editProduct($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.showpoform) ? _c('div', {}, [_c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('printProductDetails.editProduct')))]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [(_vm.clientid != '') ? _c('b-tabs', {
    staticClass: "card-header",
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": _vm.$t('printProductDetails.basicInfo'),
      "title-link-class": _vm.linkClass(0)
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.table.columns.merchantName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.merchantname),
      expression: "addproduct.merchantname"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('merchantname')
    },
    attrs: {
      "type": "text",
      "name": "merchantid",
      "id": "merchantname",
      "data-vv-scope": "tab1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addproduct.merchantname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.merchantPlaceholder')))]), _vm._v(" "), _vm._l((_vm.listMerchantData), function(Merchant_obj) {
    return _c('option', {
      domProps: {
        "value": Merchant_obj.merchantid
      }
    }, [_vm._v(_vm._s(Merchant_obj.merchantname))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('merchantid')),
      expression: "errors.has('merchantid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('merchantid')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.table.columns.clientProductId')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min: 5
      }),
      expression: "{required:true,min:5}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.clientproductid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.client'),
      "name": "clientproductid",
      "id": "clientproductid",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.clientproductid),
      callback: function($$v) {
        _vm.addproduct.clientproductid = $$v
      },
      expression: "addproduct.clientproductid"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.clientproductid')),
      expression: "errors.has('tab1.clientproductid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.clientProductIdPlaceHolder')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.table.columns.eanCode')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:5'),
      expression: "'min:5'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.eancode')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.eanCodePlaceHolder'),
      "name": "eancode",
      "id": "eancode",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.eancode),
      callback: function($$v) {
        _vm.addproduct.eancode = $$v
      },
      expression: "addproduct.eancode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.eancode')),
      expression: "errors.has('tab1.eancode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tab1.eancode')) + "\n                          ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('product.table.columns.productName')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.Productname')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.productNamePlaceHolder'),
      "name": "Productname",
      "id": "Productname",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.productname),
      callback: function($$v) {
        _vm.addproduct.productname = $$v
      },
      expression: "addproduct.productname"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.Productname')),
      expression: "errors.has('tab1.Productname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productNameError')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.productDescription')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.Productdescription')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.productDescriptionPlaceHolder'),
      "name": "Productdescription",
      "id": "Productdescription",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.productdescription),
      callback: function($$v) {
        _vm.addproduct.productdescription = $$v
      },
      expression: "addproduct.productdescription"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.Productdescription')),
      expression: "errors.has('tab1.Productdescription')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productDescriptionError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('removeHold.productMrp')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal'),
      expression: "'required|decimal'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.ProductMRP')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.mrpPlaceHolder'),
      "name": "ProductMRP",
      "id": "ProductMRP",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.mrp),
      callback: function($$v) {
        _vm.addproduct.mrp = $$v
      },
      expression: "addproduct.mrp"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.ProductMRP')),
      expression: "errors.has('tab1.ProductMRP')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.mrpError')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productTaxPlaceHolder')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Producttax')
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('productPlaceHolder.productTaxPlaceHolder'),
      "name": "Producttax",
      "id": "Producttax",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.productTax),
      callback: function($$v) {
        _vm.addproduct.productTax = $$v
      },
      expression: "addproduct.productTax"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Producttax')),
      expression: "errors.has('Producttax')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Producttax')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productCategory')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.productcategoryname),
      expression: "addproduct.productcategoryname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.productcategoryname')
    },
    attrs: {
      "name": "productcategoryname",
      "id": "productcategoryname",
      "data-vv-scope": "tab1"
    },
    on: {
      "click": _vm.getSubcategoryList,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addproduct.productcategoryname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productCategoryPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listProductCategory), function(Category_obj) {
    return _c('option', {
      domProps: {
        "value": Category_obj.productcategory
      }
    }, [_vm._v(_vm._s(Category_obj.productcategory))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.productcategoryname')),
      expression: "errors.has('tab1.productcategoryname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productCategoryError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.productSubCategory')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-globe'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.productsubcategory),
      expression: "addproduct.productsubcategory"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.subcategoryname')
    },
    attrs: {
      "name": "subcategoryname",
      "id": "subcategoryname",
      "data-vv-scope": "tab1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addproduct.productsubcategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productSubCategoryPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listProductsubCategory), function(Subcategory_obj) {
    return _c('option', {
      domProps: {
        "value": Subcategory_obj.productsubcategory
      }
    }, [_vm._v(_vm._s(Subcategory_obj.productsubcategory))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.subcategoryname')),
      expression: "errors.has('tab1.subcategoryname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Product Subcategory field is required")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.brand')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Brand')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.brandPlaceHolder'),
      "name": "Brand",
      "id": "Brand",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.brand),
      callback: function($$v) {
        _vm.addproduct.brand = $$v
      },
      expression: "addproduct.brand"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.Brand')),
      expression: "errors.has('tab1.Brand')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.brandError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.productType')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.producttype')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.productTypePlaceHolder'),
      "name": "producttype",
      "id": "producttype",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.producttype),
      callback: function($$v) {
        _vm.addproduct.producttype = $$v
      },
      expression: "addproduct.producttype"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.producttype')),
      expression: "errors.has('tab1.producttype')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tab1.producttype')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.table.columns.hsnCode')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.HSNcode')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.hsnCodePlaceHolder'),
      "name": "HSNcode",
      "id": "HSNcode",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.hsncode),
      callback: function($$v) {
        _vm.addproduct.hsncode = $$v
      },
      expression: "addproduct.hsncode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.HSNcode')),
      expression: "errors.has('tab1.HSNcode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.hsnCodeError')) + "\n                          ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.gstRate')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.GSTrate')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.gstraratePlaceHolder'),
      "name": "GSTrate",
      "id": "GSTrate",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.hsnrate),
      callback: function($$v) {
        _vm.addproduct.hsnrate = $$v
      },
      expression: "addproduct.hsnrate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.GSTrate')),
      expression: "errors.has('tab1.GSTrate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.gstrarateError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.activemrpflag) ? _c('b-form-fieldset', [_c('label', [_vm._v("Active MRP")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal'),
      expression: "'required|decimal'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "activemrp",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.activemrp),
      callback: function($$v) {
        _vm.addproduct.activemrp = $$v
      },
      expression: "addproduct.activemrp"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.activemrp')),
      expression: "errors.has('tab1.activemrp')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Active MRP")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [(_vm.productUploadLabelUrl) ? _c('i', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _c('img', {
    attrs: {
      "src": _vm.productUploadLabelUrl,
      "width": "150px"
    },
    on: {
      "load": function($event) {
        _vm.myevent(_vm.productUploadLabelUrl)
      }
    }
  })], 1) : _vm._e(), _c('br'), _vm._v(" "), (!_vm.productUploadLabelUrl) ? _c('i', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _c('img', {
    attrs: {
      "src": "static/img/noimg.png",
      "width": "150px"
    },
    on: {
      "load": function($event) {
        _vm.myevent()
      }
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.filetype),
      expression: "addproduct.filetype"
    }],
    attrs: {
      "type": "radio",
      "value": "Upload"
    },
    domProps: {
      "checked": _vm._q(_vm.addproduct.filetype, "Upload")
    },
    on: {
      "__c": function($event) {
        _vm.addproduct.filetype = "Upload"
      }
    }
  }), _vm._v(_vm._s(_vm.$t('printProductDetails.fileUpload')) + "\n                           ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.filetype),
      expression: "addproduct.filetype"
    }],
    attrs: {
      "type": "radio",
      "value": "url"
    },
    domProps: {
      "checked": _vm._q(_vm.addproduct.filetype, "url")
    },
    on: {
      "__c": function($event) {
        _vm.addproduct.filetype = "url"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('printProductDetails.imageUrl')) + "\n                           ")])], 1), _vm._v(" "), (this.addproduct.filetype == 'url') ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.fileUpload')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.File Upload')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.fileUploadPlaceholder'),
      "name": "File Upload",
      "id": "File Upload",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.fileupload),
      callback: function($$v) {
        _vm.addproduct.fileupload = $$v
      },
      expression: "addproduct.fileupload"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tab1.File Upload')),
      expression: "errors.has('tab1.File Upload')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tab1.File Upload')))])], 1)], 1) : _vm._e(), _vm._v(" "), (this.addproduct.filetype == 'Upload') ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.productImage')))]), _vm._v(" "), _c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "id": "Image",
      "value": "",
      "name": "Image",
      "data-vv-scope": "tab1"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveImage('Productimage', 'file')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(_vm._s(_vm.$t('product.upload')))])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "float-right"
  }, [_c('b-button-group', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.validateTab()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.nextBtn')) + " "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])]), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('printProductDetails.details'),
      "title-link-class": _vm.linkClass(1)
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "isfragile",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.isfragile),
      callback: function($$v) {
        _vm.addproduct.isfragile = $$v
      },
      expression: "addproduct.isfragile"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isFragile')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "isflammable",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.isflammable),
      callback: function($$v) {
        _vm.addproduct.isflammable = $$v
      },
      expression: "addproduct.isflammable"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isflammable')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "isliquid",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.isliquid),
      callback: function($$v) {
        _vm.addproduct.isliquid = $$v
      },
      expression: "addproduct.isliquid"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isLiquid')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "istempsensitive",
      "value": 1
    },
    on: {
      "change": _vm.temsensitiveChange
    },
    model: {
      value: (_vm.addproduct.istempsensitive),
      callback: function($$v) {
        _vm.addproduct.istempsensitive = $$v
      },
      expression: "addproduct.istempsensitive"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isTempSensitive')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "serializecontrol",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.serializecontrol),
      callback: function($$v) {
        _vm.addproduct.serializecontrol = $$v
      },
      expression: "addproduct.serializecontrol"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.serializeControl')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "ishazardous",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.ishazardous),
      callback: function($$v) {
        _vm.addproduct.ishazardous = $$v
      },
      expression: "addproduct.ishazardous"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isHazardous')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "isserialcontrol",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.isserialcontrol),
      callback: function($$v) {
        _vm.addproduct.isserialcontrol = $$v
      },
      expression: "addproduct.isserialcontrol"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.serializeControl')))])], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "lotcontrol",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.lotcontrol),
      callback: function($$v) {
        _vm.addproduct.lotcontrol = $$v
      },
      expression: "addproduct.lotcontrol"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isLotcontrol')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "expirycontrolled",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.expirycontrolled),
      callback: function($$v) {
        _vm.addproduct.expirycontrolled = $$v
      },
      expression: "addproduct.expirycontrolled"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.expiryControlled')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "ismrptracked",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.ismrptracked),
      callback: function($$v) {
        _vm.addproduct.ismrptracked = $$v
      },
      expression: "addproduct.ismrptracked"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('printProductDetails.isMRPTracked')))])], 1)])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.addproduct.istempsensitive) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.minTemp')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-thermometer'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Min Temp')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerceProduct.minTempPlaceholder'),
      "name": "Min Temp",
      "id": "Min Temp"
    },
    model: {
      value: (_vm.addproduct.mintemp),
      callback: function($$v) {
        _vm.addproduct.mintemp = $$v
      },
      expression: "addproduct.mintemp"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Min Temp')),
      expression: "errors.has('Min Temp')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Min Temp')))]), _vm._v(" "), (_vm.ismintempError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.UOMminerrors))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.maxTemp')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-thermometer'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Max Temp')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerceProduct.maxTempPlaceholder'),
      "name": "Max Temp",
      "id": "Max Temp"
    },
    on: {
      "keyup": _vm.Checktemp
    },
    model: {
      value: (_vm.addproduct.maxtemp),
      callback: function($$v) {
        _vm.addproduct.maxtemp = $$v
      },
      expression: "addproduct.maxtemp"
    }
  })], 1), _vm._v(" "), (_vm.isError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.Qtyerrors))]) : _vm._e(), _vm._v(" "), (_vm.ismaxtempError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.UOMmaxerrors))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.uomTemp')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-thermometer'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.uomtemp),
      expression: "addproduct.uomtemp"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('UOM Temp')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerceProduct.UOMTempPlaceholder'),
      "name": "UOM Temp",
      "id": "UOM Temp"
    },
    domProps: {
      "value": (_vm.addproduct.uomtemp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addproduct.uomtemp = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.isuomtempError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.UOMtemperrors))]) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.addproduct.expirycontrolled) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.shelfLifeDuration')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('Shelf Life Duration')
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('productPlaceHolder.shelfLifeDurationPlaceHolder'),
      "name": "Shelf Life Duration",
      "id": "Shelf Life Duration"
    },
    on: {
      "keyup": _vm.lifeuom
    },
    model: {
      value: (_vm.addproduct.shelflifeduration),
      callback: function($$v) {
        _vm.addproduct.shelflifeduration = $$v
      },
      expression: "addproduct.shelflifeduration"
    }
  })], 1), _vm._v(" "), (_vm.isshelflifeError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.shelflifeerrors) + "\n                          ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.primaryUom')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('Primary Uom')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.primaryUomPlaceHolder'),
      "name": "Primary Uom",
      "id": "Primary Uom"
    },
    model: {
      value: (_vm.addproduct.primaryuom),
      callback: function($$v) {
        _vm.addproduct.primaryuom = $$v
      },
      expression: "addproduct.primaryuom"
    }
  })], 1), _vm._v(" "), (_vm.ispuomError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.puomerrors))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.secondaryUom')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Secondary uom')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.secondaryUomPlaceHolder'),
      "name": "Secondary uom",
      "id": "Secondary uom"
    },
    model: {
      value: (_vm.addproduct.secondaryuom),
      callback: function($$v) {
        _vm.addproduct.secondaryuom = $$v
      },
      expression: "addproduct.secondaryuom"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Secondary uom')),
      expression: "errors.has('Secondary uom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Secondary uom')))])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("\n                            " + _vm._s(_vm.$t('printProductDetails.unitDimensonUom')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('decimal'),
      expression: "'decimal'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('UnitDimensonuom')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.unitDimensonUomPlaceHolder'),
      "name": "UnitDimensonuom",
      "id": "UnitDimensonuom"
    },
    model: {
      value: (_vm.addproduct.unitdimensonuom),
      callback: function($$v) {
        _vm.addproduct.unitdimensonuom = $$v
      },
      expression: "addproduct.unitdimensonuom"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('UnitDimensonuom')),
      expression: "errors.has('UnitDimensonuom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('UnitDimensonuom')) + "\n                          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.unitWeight')) + "\n                          ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        decimal: true,
        required: true,
        min_value: 0
      }),
      expression: "{decimal:true,required:true,min_value:0}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Unit Weight')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.unitWeightPlaceHolder'),
      "name": "Unit Weight",
      "id": "Unit Weight"
    },
    model: {
      value: (_vm.addproduct.unitweight),
      callback: function($$v) {
        _vm.addproduct.unitweight = $$v
      },
      expression: "addproduct.unitweight"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Unit Weight')),
      expression: "errors.has('Unit Weight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.unitWeightError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.unitLength')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        decimal: true,
        required: true,
        min_value: 0
      }),
      expression: "{decimal:true,required:true,min_value:0}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Unit length')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.unitLengthPlaceHolder'),
      "name": "Unit length",
      "id": "Unit length"
    },
    model: {
      value: (_vm.addproduct.unitlength),
      callback: function($$v) {
        _vm.addproduct.unitlength = $$v
      },
      expression: "addproduct.unitlength"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Unit length')),
      expression: "errors.has('Unit length')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.unitlengthError')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.unitBreadth')) + "\n                            ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        decimal: true,
        required: true,
        min_value: 0
      }),
      expression: "{decimal:true,required:true,min_value:0}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Unit Breadth')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.unitBreadthPlaceHolder'),
      "name": "Unit Breadth",
      "id": "Unit Breadth"
    },
    model: {
      value: (_vm.addproduct.unitbreadth),
      callback: function($$v) {
        _vm.addproduct.unitbreadth = $$v
      },
      expression: "addproduct.unitbreadth"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Unit Breadth')),
      expression: "errors.has('Unit Breadth')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.unitBreadthError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.unitHeight')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        decimal: true,
        required: true,
        min_value: 0
      }),
      expression: "{decimal:true,required:true,min_value:0}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Unit Height')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.unitHeightPlaceHolder'),
      "name": "Unit Height",
      "id": "Unit Height"
    },
    model: {
      value: (_vm.addproduct.unitheight),
      callback: function($$v) {
        _vm.addproduct.unitheight = $$v
      },
      expression: "addproduct.unitheight"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Unit Height')),
      expression: "errors.has('Unit Height')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.unitHeightError')) + "\n                          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.mfgCode')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-envelope'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('MFG code')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.mfgCodePlaceHolder'),
      "name": "MFG code",
      "id": "MFG code"
    },
    model: {
      value: (_vm.addproduct.mfgcode),
      callback: function($$v) {
        _vm.addproduct.mfgcode = $$v
      },
      expression: "addproduct.mfgcode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('MFG code')),
      expression: "errors.has('MFG code')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('MFG code')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.attribute1')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('attribute1')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.attribute1PlaceHolder'),
      "name": "attribute1",
      "id": "attribute1"
    },
    model: {
      value: (_vm.addproduct.attribute1),
      callback: function($$v) {
        _vm.addproduct.attribute1 = $$v
      },
      expression: "addproduct.attribute1"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('attribute1')),
      expression: "errors.has('attribute1')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('attribute1')) + "\n                          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.stickerName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('stickername')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.stickerNamePlaceHolder'),
      "name": "stickername",
      "id": "stickername"
    },
    model: {
      value: (_vm.addproduct.stickername),
      callback: function($$v) {
        _vm.addproduct.stickername = $$v
      },
      expression: "addproduct.stickername"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('stickername')),
      expression: "errors.has('stickername')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('stickername')) + "\n                          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("\n                            " + _vm._s(_vm.$t('printProductDetails.subBrand')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('subbrand')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.subBrandPlaceHolder'),
      "name": "subbrand",
      "id": "subbrand"
    },
    model: {
      value: (_vm.addproduct.subbrand),
      callback: function($$v) {
        _vm.addproduct.subbrand = $$v
      },
      expression: "addproduct.subbrand"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subbrand')),
      expression: "errors.has('subbrand')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('subbrand')) + "\n                          ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.size')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-arrows'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('size')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.sizePlaceHolder'),
      "name": "size",
      "id": "size"
    },
    model: {
      value: (_vm.addproduct.size),
      callback: function($$v) {
        _vm.addproduct.size = $$v
      },
      expression: "addproduct.size"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('size')),
      expression: "errors.has('size')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('size')) + "\n                          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.color')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('color')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.colorPlaceHolder'),
      "name": "color",
      "id": "color"
    },
    model: {
      value: (_vm.addproduct.color),
      callback: function($$v) {
        _vm.addproduct.color = $$v
      },
      expression: "addproduct.color"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('color')),
      expression: "errors.has('color')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('color')) + "\n                          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.velocityCode')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('velocitycode')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.velocityCodePlaceHolder'),
      "name": "velocitycode",
      "id": "velocitycode"
    },
    model: {
      value: (_vm.addproduct.velocitycode),
      callback: function($$v) {
        _vm.addproduct.velocitycode = $$v
      },
      expression: "addproduct.velocitycode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('velocitycode')),
      expression: "errors.has('velocitycode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('velocitycode')) + "\n                          ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.unitPrice')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-file'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('unitprice')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.unitPricePlaceHolder'),
      "name": "unitprice",
      "id": "unitprice"
    },
    model: {
      value: (_vm.addproduct.unitprice),
      callback: function($$v) {
        _vm.addproduct.unitprice = $$v
      },
      expression: "addproduct.unitprice"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('unitprice')),
      expression: "errors.has('unitprice')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.unitPricePlaceHolder')) + "\n                          ")])], 1)], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clientfooter form-actions"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.editProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('printProductDetails.update')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetform
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("  " + _vm._s(_vm.$t('printProductDetails.cancel')))]), _vm._v(" "), _c('div', {
    staticClass: "float-left"
  }, [_c('b-button-group', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.tabIndex = 0
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v("  " + _vm._s(_vm.$t('printProductDetails.previous')))])])], 1)])])], 1) : _vm._e()], 1)])], 1) : _vm._e()])])])], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42b812f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42b812f4","hasScoped":true}!./src/views/components/product/product.component.html
// module id = 1427
// module chunks = 0